import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import ic_filter from '../../assets/ic_filter.svg'
import { Button } from "../../common/Button/Button";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import downloadIcon from '../../assets/downloadIcon.png'
import { Info } from "react-feather";

const MergedPartnerResourceTable = (props) => {

  const [MergedPartnerResourceModal, setMergedPartnerResourceModal] = useState(false)

  const gridRef = useRef()
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  //   const rowData = props.data

  const data = props.firstTimeData
  const data2 = props.engagedData

  const [rowData, setRowData] = useState([]);
  const [resourseNames, setResourseNames] = useState([]);
  const [partnerNames, setPartnerNames] = useState([])
  const [MergedData, setMergedData] = useState([]);

  useEffect(() => {
    const mergedData = [];

    // Iterate over the first dataset
    data.forEach(item1 => {
      const mergedItem = {
        entrypoint_name: item1.entrypoint_name,
        resourcedisplay_name: item1.resourcedisplay_name,
        first_time_data: item1.resourse_count,
        engaged_count: 0,
      };

      // Find a matching item in the second dataset
      const matchingItem = data2.find(item2 => (
        item2.entrypoint_name === item1.entrypoint_name &&
        item2.resourcedisplay_name === item1.resourcedisplay_name
      ));

      // If a matching item is found, update the engaged_count
      if (matchingItem) {
        mergedItem.engaged_count = matchingItem.resourse_count;
      }

      mergedData.push(mergedItem);
    });

    // Iterate over the second dataset to find any missing entries
    data2.forEach(item2 => {
      const matchingItem = mergedData.find(item => (
        item.entrypoint_name === item2.entrypoint_name &&
        item.resourcedisplay_name === item2.resourcedisplay_name
      ));

      // If a matching item is not found, add it to the merged dataset with first_time_data as 0
      if (!matchingItem) {
        mergedData.push({
          entrypoint_name: item2.entrypoint_name,
          resourcedisplay_name: item2.resourcedisplay_name,
          first_time_data: 0,
          engaged_count: item2.resourse_count,
        });
      }
    });

    console.log("MergData", mergedData);

    const partnerNamesSet = new Set(mergedData.map(data => data.entrypoint_name));
    const partnerNames = Array.from(partnerNamesSet);
    const ResourseNamesSet = new Set(mergedData.map(data => data.resourcedisplay_name));
    const resourseNames = Array.from(ResourseNamesSet);
    setPartnerNames(partnerNames)
    setResourseNames(resourseNames)
    setRowData(mergedData)
    setMergedData(mergedData)
  }, [data, data2])

  useEffect(() => {
    if (props.selectedOptionsMergedPartnerResource.length > 0) {
      const filteredData = MergedData.filter(obj => props.selectedOptionsMergedPartnerResource.some(item => item.value === obj.entrypoint_name));
      console.log("Filt Data", filteredData);
      let arr1 = []
      filteredData.map((ele) => {
        if (ele.resourcedisplay_name != "" && ele.resourcedisplay_name != null) {
          arr1.push(ele.resourcedisplay_name)
        }
      });
      setResourseNames(arr1);
    } else {
      const sourceNames = MergedData.reduce((uniqueNames, row) => {
          if (row.resourcedisplay_name && (row.resourcedisplay_name != null && row.resourcedisplay_name != "") && !uniqueNames.includes(row.resourcedisplay_name)) {
            uniqueNames.push(row.resourcedisplay_name);
          }
          return uniqueNames;
        }, []);
        setResourseNames(sourceNames)
  }
  }, [props.selectedOptionsMergedPartnerResource, MergedData])

  useEffect(() => {
    if (props.selectedOptionsMergedPartnerResourceEu.length > 0) {
      const filteredData = MergedData.filter(obj => props.selectedOptionsMergedPartnerResourceEu.some(item => item.value === obj.resourcedisplay_name));
      console.log("Filt Data", filteredData);
      let arr1 = []
      filteredData.map((ele) => {
        if (ele.entrypoint_name != "" && ele.entrypoint_name != null) {
          arr1.push(ele.entrypoint_name)
        }
      });
      setPartnerNames(arr1);
    } else {
      const mediumNames = MergedData.reduce((uniqueNames, row) => {
          if (row.entrypoint_name && (row.entrypoint_name != null && row.entrypoint_name != "") && !uniqueNames.includes(row.entrypoint_name)) {
            uniqueNames.push(row.entrypoint_name);
          }
          return uniqueNames;
        }, []);
        setPartnerNames(mediumNames)
  }
  }, [props.selectedOptionsMergedPartnerResourceEu, MergedData])

  const footerRow = {
    resourcedisplay_name: "Total",
    first_time_data: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.first_time_data, 0),
    engaged_count: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.engaged_count, 0),
  };

  const openMergedPartnerResourceModalisTrue = () => {
    setMergedPartnerResourceModal(true)
  }

  const openMergedPartnerResourceModalisFalse = () => {
    setMergedPartnerResourceModal(false)
  }

  const handleClearClick = () => {
    props.setSelectedOptionsMergedPartnerResource([])
    props.setSelectedOptionsMergedPartnerResourceEu([])
  }

  const CustomCellRenderer = (props) => {
    let resourceName = props.value;
    if (resourceName === null) {
      resourceName = "Not Provided";
    }
    if (resourceName === "Total") {
      return <div style={{ textAlign: "right", display: "none" }}>{resourceName}</div>;
    } else {
      return <div>{resourceName}</div>;
    }
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "entrypoint_name",
      headerName: "Partner Name",
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
            <div style={{ marginRight: "110px" }}>{params.displayName}</div>
            {/* <img
                alt=""
                src={ic_filter}
                height={"25px"}
                width={"25px"}
                className="conv-mr10"
                onClick={() => openMergedPartnerResourceModalisTrue()}
            /> */}
          </div>
        );
      },
      width: 380,
      cellStyle: { 'white-space': 'normal' },
      autoHeight: true,
      cellRendererFramework: CustomCellRenderer,
      //   cellRenderer: params => {
      //     let resourseName = params.value;
      //     if (resourseName === null) {
      //       resourseName = "Not Provided";
      //     }
      //     if (resourseName === "Total") {
      //       return <div style={{ textAlign: "right", display: 'none' }}>{resourseName}</div>;
      //     } else {
      //       return resourseName;
      //     }
      //   },
    },
    {
      field: "resourcedisplay_name",
      headerName: "Resource Utilised",
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
            <div style={{ marginRight: "210px" }}>{params.displayName}</div>
            <img
              alt=""
              src={ic_filter}
              height={"25px"}
              width={"25px"}
              className="conv-mr10"
              onClick={() => openMergedPartnerResourceModalisTrue()}
            />
          </div>
        );
      },
      width: 380,
      cellStyle: { 'white-space': 'normal' },
      autoHeight: true,
      cellRendererFramework: CustomCellRenderer,
      // cellRenderer: params => {
      //   let resourseName = params.value;
      //   if (resourseName === null) {
      //     resourseName = "Not Provided";
      //   }
      //   if (resourseName === "Total") {
      //     return <div style={{ textAlign: "right", display: 'none' }}>{resourseName}</div>;
      //   } else {
      //     return resourseName;
      //   }
      // },
    },
    {
      field: "first_time_data",
      headerName: "First Time Count",
      // width: 180,
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
    {
      field: "engaged_count",
      headerName: "Engaged Count",
      // width: 180,
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
  ]);

  const handleMergedPartnerResourceSelect = (selected) => {
    props.setSelectedOptionsMergedPartnerResource(selected)
    console.log("select", props.selectedOptionsMergedPartnerResource)
  }

  const handleMergedPartnerResourceSelectEu = (selected) => {
    props.setSelectedOptionsMergedPartnerResourceEu(selected)
    console.log("select", props.selectedOptionsMergedPartnerResourceEu)
  }

  const handleMergedPartnerResourceFilterSearchClick = () => {
    if (props.selectedOptionsMergedPartnerResource.length > 0 && props.selectedOptionsMergedPartnerResourceEu.length > 0) {
      const filteredPartnerData = MergedData.filter((partner) =>
        props.selectedOptionsMergedPartnerResource.some((option) => option.value === partner.entrypoint_name) &&
        props.selectedOptionsMergedPartnerResourceEu.some((option) => option.value === partner.resourcedisplay_name)
      );
      console.log(filteredPartnerData);
      setRowData(filteredPartnerData);
    }
    else if (props.selectedOptionsMergedPartnerResource.length > 0) {
      const filteredPartnerData = MergedData.filter((partner) =>
        props.selectedOptionsMergedPartnerResource.some((option) => option.value === partner.entrypoint_name)
      );
      console.log(filteredPartnerData);
      setRowData(filteredPartnerData);
    } else if (props.selectedOptionsMergedPartnerResourceEu.length > 0) {
      const filteredPartnerData = MergedData.filter((partner) =>
        props.selectedOptionsMergedPartnerResourceEu.some((option) => option.value === partner.resourcedisplay_name)
      );
      console.log(filteredPartnerData);
      setRowData(filteredPartnerData);
    } else {
      setRowData(MergedData);
    }
    openMergedPartnerResourceModalisFalse();
  }

  const gridOptions = useMemo(() => ({
    suppressScrollOnNewData: true,
  }), []);

  // const handleDownloadCSV = () => {
  //   const csvData = [];
  //   csvData.push('Partner Name, Resource Utilised, First Time Count, Engaged Count'); // CSV header

  //   rowData.forEach(row => {
  //     csvData.push(`${row.entrypoint_name}, ${row.resourcedisplay_name}, ${row.first_time_data}, ${row.engaged_count}`);
  //   });

  //   const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv' });
  //   const csvUrl = window.URL.createObjectURL(csvBlob);

  //   const downloadLink = document.createElement('a');
  //   downloadLink.href = csvUrl;
  //   downloadLink.download = 'partner_resource_data.csv';
  //   downloadLink.style.display = 'none';
  //   document.body.appendChild(downloadLink);
  //   downloadLink.click();

  //   window.URL.revokeObjectURL(csvUrl);
  //   document.body.removeChild(downloadLink);
  // };

  const handleDownloadCSV = () => {
    const csvData = [];
    csvData.push('Partner Name, Resource Utilized, First Time Count, Engaged Count'); // CSV header
  
    rowData.forEach(row => {
      // Check if 'entrypoint_name' and 'resourcedisplay_name' are null or empty
      const partnerName = (row.entrypoint_name !== null && row.entrypoint_name !== '') ? row.entrypoint_name.replace(/\n/g, ' ') : (row.entrypoint_name === null ? 'null' : '');
      const resourceUtilized = (row.resourcedisplay_name !== null && row.resourcedisplay_name !== '') ? row.resourcedisplay_name.replace(/\n/g, ' ') : (row.resourcedisplay_name === null ? 'null' : '');
  
      // Escape double quotes in 'partnerName' and 'resourceUtilized' to avoid CSV issues
      const escapedPartnerName = partnerName.replace(/"/g, '""');
      const escapedResourceUtilized = resourceUtilized.replace(/"/g, '""');
  
      // Create the CSV row
      csvData.push(`${escapedPartnerName}, ${escapedResourceUtilized}, ${row.first_time_data}, ${row.engaged_count}`);
    });

  
    const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv' });
    const csvUrl = window.URL.createObjectURL(csvBlob);

  
    const downloadLink = document.createElement('a');
    downloadLink.href = csvUrl;
    downloadLink.download = 'partner_resource_data.csv';
    downloadLink.style.display = 'none';
    document.body.appendChild(downloadLink);
    downloadLink.click();

  
    window.URL.revokeObjectURL(csvUrl);
    document.body.removeChild(downloadLink);
  };



  return (
    <div>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      // justifyContent: 'center',
      margin: 10
    }}>
      <h3 className="spled-colored-label" style={{
        fontSize: "20px",
        textAlign: 'center',
        marginRight: 10
      }}>5. First time and Engaged Users based on Partner / Resource Availed</h3>
      <span style={{ cursor: "pointer" }} title="Display of First time users and engaged users based on Partner / Resource Availed by partner entry points">
        <Info style={{ width: "15px", marginRight: "10px", marginBottom:"5px" }} />
      </span>
      {
        rowData.length > 0 && (
          // <Button className="esp-inline-button"
          //   onClick={handleDownloadCSV}
          // >Download CSV</Button>
          <img src={downloadIcon} title="Download CSV" alt="" onClick={handleDownloadCSV} style={{
            cursor: "pointer"
          }} />
        )
      }
    </div>

    <div style={{
      height: "50vh",
    }}>
      <div style={{ height: "100%", boxSizing: "border-box" }}>
        <div style={gridStyle} className="ag-theme-material">
          <AgGridReact ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            pinnedBottomRowData={[footerRow]}
            gridOptions={gridOptions}
            overlayNoRowsTemplate={
              '<span class="ag-overlay-loading-center">loading...</span>'
            }
            rowClassRules={{
              'total-row': 'data.resourcedisplay_name === "Total"'
            }}
          >
          </AgGridReact>
        </div>
      </div>

      <Modal isOpen={MergedPartnerResourceModal}>
        <ModalContent className="EngagedDashboard-filter-modal">
          <div className="modal-header">
            <span className="modal-title">Filter</span>
            <img
              alt="close"
              id="Close"
              src={close_modal}
              className="close modal-close"
              onClick={openMergedPartnerResourceModalisFalse}
            />
          </div>

          <div className="modal-body">
            <br />
            <div className="row">
              <div className="col-6 spled-container">
                <div className="width-100">
                  <ReactMultiSelectCheckboxes
                    options={partnerNames.map((partner) => ({
                      label: partner,
                      value: partner,
                    }))}
                    // placeholder="Select partners"
                    placeholderButtonLabel="Select Partner"
                    value={props.selectedOptionsMergedPartnerResource}
                    onChange={handleMergedPartnerResourceSelect}
                  />
                </div>
              </div>
              <div className="col-6 spled-container">
                <div className="width-100">
                  <ReactMultiSelectCheckboxes
                    options={resourseNames.map((program) => ({
                      label: program,
                      value: program,
                    }))}
                    // placeholder="Select partners"
                    placeholderButtonLabel="Select Resource"
                    value={props.selectedOptionsMergedPartnerResourceEu}
                    onChange={handleMergedPartnerResourceSelectEu}
                  />
                </div>
              </div>
            </div>
            <br />
            <div className='row d-flex justify-content-center align-items-center'>
            <div className="offset-1 col-5">
                <Button className="esp-inline-button" onClick={handleMergedPartnerResourceFilterSearchClick}>Search</Button>
              </div>
              <div className="col-5">
                <Button className="esp-inline-button" onClick={handleClearClick}>Clear</Button>
              </div>
              {/* <div className="col-4"></div> */}
            </div>

          </div>
        </ModalContent>
      </Modal>
    </div>
    </div>
  )
}

export default MergedPartnerResourceTable
